<template v-slot:default="{ availablePos }">
  <div class="py-4">
    <LoadingJoinnus v-if="showLoadingJoinnus"></LoadingJoinnus>
    <div class="container">
      <SearchForm v-show="step === 1" @submit="searchSubmit($event)"></SearchForm>
      <Loader v-show="loading"></Loader>
      <div v-show="!loading">
        <!-- step 1: lista eventos -->
        <div v-show="step === 1">
          <h3 v-if="!events.length">Sin resultados.</h3>
          <div v-else>
            <EventsList :events="events" @eventSelected="getEventSelected" @update-cart="updateCart($event)"></EventsList>
          </div>
        </div>
        <!-- step 2: carrito -->
        <div v-show="step === 2">
          <div class="my-4">
            <CartEvents
              @apply-coupon="setCoupon"
              @setTotalDiscountByEvent="totalDiscount"
              @totalsByEvent="totalsByEvent = $event"
              :currency="meta.currency"
            >
            </CartEvents>
          </div>
          <div class="row justify-content-between">
            <div class="col">
              <button @click="goStep(1)" class="btn btn-secondary btn-lg" type="button">
                Seguir comprando
              </button>
            </div>
            <div v-if="cart.length" class="col-auto">
              <button @click="goStep(3)" class="btn btn-action btn-lg" type="button">
                Pagar ahora: {{ meta.currency }}
                <small v-if="coupon.code" class="mr-2" style="text-decoration: line-through">
                  {{ meta.total + commission }}
                </small>
                <b>{{ (totalPay + commission).toFixed(2) }}</b>
              </button>
            </div>
          </div>
        </div>
        <!-- step 3: datos -->
        <div v-show="step === 3">
          <h2 class="mb-3">Separar entrada</h2>
          <UserDataBuyEvents
            ref="formUserData"
            @submit="registerDataUser($event)"
            :eventSelected="eventSelected"
          ></UserDataBuyEvents>
        </div>
        <!-- step 4: pago en partes -->
        <div v-show="step === 4">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-11 col-xl-10">
              <div class="card shadow-sm">
                <div class="card-body pt-5 px-5">
                  <h2 class="mb-5 d-flex align-items-center">
                    <button @click="goStep(3)" class="btn btn-outline-secondary btn-sm mr-4">
                      Atrás
                    </button>
                    <span>Elige opción de compra</span>
                  </h2>
                </div>
                <div class="mb-4 px-5">
                  <Shopping :meta="meta" v-if="step === 4" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- forma de pago -->
        <div v-show="step === 5">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-11 col-xl-10">
              <div class="card shadow-sm">
                <div class="card-body py-5 px-md-5">
                  <h2 class="mb-5 d-flex align-items-center">
                    <button @click="returnPage()" class="btn btn-outline-secondary btn-sm mr-4">
                      Atrás
                    </button>
                    <span>{{ isFreeSale ? 'Confirmar entrega' : 'Formas de pago' }}</span>
                  </h2>
                  <div v-if="isFreeSale" class="mb-4">
                    <b-alert show variant="success">
                      <b>{{ isCourtesy ? 'Venta de cortesía' : 'Venta sin costo' }}</b>
                      <div>No se realizará ningún cobro.</div>
                    </b-alert>
                    <div class="card bg-light">
                      <div class="card-body p-3">
                        <div><b>Comprador:</b> {{ user.name }} {{ user.lastname }}</div>
                        <div v-if="cartEventTitles.length">
                          <b>{{ cartEventTitles.length > 1 ? 'Eventos:' : 'Evento:' }}</b>
                          {{ cartEventTitles.join(', ') }}
                        </div>
                        <div><b>Entradas:</b> {{ meta.totalProducts }}</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="mb-4">
                    <PayMethods
                      v-model="formPay"
                      :couponFree="true"
                      @part-payment="setPartPayment($event)"
                      :showYape="yapeActive"
                    >
                    </PayMethods>
                  </div>
                  <form @submit.prevent="modals.confirm = true">
                    <!-- <div class="text-right mb-3">
                      <b-form-checkbox
                        name="checkbox-1"
                        v-model="specialPrice"
                      >
                        <b>¿Tiene precio especial?</b>
                      </b-form-checkbox>
                    </div> -->
                    <div v-if="specialPrice">
                      <div class="row">
                        <div class="col-12 col-sm-6">
                          <label class="form-group w-100">
                            <div>Motivo*</div>
                            <textarea
                              v-model="formSpecial.reason"
                              class="form-control"
                              placeholder="Motivo del precio especial"
                              required
                            ></textarea>
                          </label>
                        </div>
                        <div class="col-12 col-sm-6">
                          <label class="form-group w-100">
                            <div>Nuevo monto a pagar</div>
                            <input
                              v-model="formSpecial.amount"
                              type="number"
                              class="form-control"
                              required
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="text-right mb-4">
                      <div class="h4">
                        <small v-if="commission">
                          <b>comisión kasnet: </b> {{ meta.currency }} {{ commission }} </small
                        ><br />
                        <b>Total a pagar: </b> {{ meta.currency }}
                        <small
                          v-if="isFreeSale && Number(totalWithCommission) > 0"
                          class="mr-2"
                          style="text-decoration: line-through"
                        >
                          {{ totalWithCommission }}
                        </small>
                        {{ isFreeSale ? '0.00' : totalWithCommission }}
                      </div>
                    </div>
                    <div class="text-right">
                      <button
                        class="btn btn-action btn-lg"
                        type="submit"
                        :disabled="!isFreeSale && formPay.type === 'pos' && !formPay.code"
                      >
                        Generar entradas
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="step === 6">
          <div class="row justify-content-center">
            <div class="col-12 col-lg-9 col-xl-8 pb-3" v-if="isFeePayments">
              <CardDetailsBuyer :user="user" :transactionId="transactionId" :totalPay="totalPay" />
            </div>
            <div class="col-12 col-lg-9 col-xl-8">
              <div class="card">
                <div class="card-body py-5">
                  <h3 class="text-center">Registro de compra exitoso!!</h3>
                  <hr />
                  <br />
                  <p class="text-center">Transacción: <b>{{ transactionId }}</b></p>
                  <form v-if="sendEmailBoxOffice" @submit.stop.prevent="onSendTickets" style="display: flex; justify-content: center; margin-bottom: 1rem;">
                    <b-overlay :show="sendingEmail" rounded="sm" style="padding: 4px; padding: 4px; display: flex; gap: 4px; align-items: center;">
                      <input v-model="ticketsEmail" v-if="isDummyEmail(user.email)" type="email" placeholder="correo" required style="padding-left: 8px;" />
                      <p class="m-0" v-else>{{ user.email }}</p>
                      <button type="submit" class="btn btn-primary btn-sm">
                        Enviar entradas
                      </button>
                    </b-overlay>
                  </form>
                  <div style="display: flex; justify-content: center;">
                    <p class="text-center">
                      <a
                        :href="`${baseUrlJn}/ticket-detail/${transactionId}/pos/${
                          isFootball ? 'futbol' : 'ticket-pos-premium'
                        }`"
                        target="_blank"
                        class="btn btn-action btn-lg"
                      >
                        Imprimir
                      </a>
                    </p>
                    <!--<p v-else class="text-center">
                      <a
                        :href="`/ticket/${transactionId}/?isFootball=${isFootball}`"
                        target="_blank"
                        class="btn btn-action btn-lg"
                      >
                        Imprimir
                      </a>
                    </p>-->
                    <p class="text-center">
                      <a
                        :href="`${baseUrlJn}/ticket-detail/${transactionId}/pos`"
                        target="_blank"
                        class="btn btn-action btn-lg"
                      >
                        impresión POS
                      </a>
                    </p>
                  </div>
                  <br />
                  <p class="text-center">
                    <button @click="newSale()" type="button" class="btn btn-primary">
                      Nueva venta
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <b-modal
            v-model="modals.confirmNew"
            hide-header
            cancel-title="Cerrar"
            ok-title="Confirmar"
            ok-variant="action btn-lg ml-3"
            @ok="newShop()"
          >
            <div class="text-center">
              <p class="lead p-4">¿Estás segur@ que deseas salir de la pantalla de impresión?</p>
            </div>
          </b-modal>
        </div>
        <!-- float cart -->
        <div v-if="cart.length" @click="goStep(2)" class="cart-float shadow">
          <i class="material-icons">shopping_cart</i>
          <span class="shadow">{{ meta.totalProducts }}</span>
        </div>
        <!-- modal confirm -->
        <b-modal v-model="modals.confirm" @hidden="resetModalPayment" hide-header hide-footer>
          <div class="my-5 text-center">
            <h5>
              <b>
                Total a pagar: {{ meta.currency }}
                <small
                  v-if="isFreeSale && Number(totalWithCommission) > 0"
                  class="mr-2"
                  style="text-decoration: line-through"
                >
                  {{ totalWithCommission }}
                </small>
                {{ isFreeSale ? '0.00' : totalWithCommission }}
              </b>
            </h5>
            <br />
            <h4>
              ¿Estás seguro que deseas realizar la transacción con Método de pago: <br />
              <b class="text-uppercase" v-if="isFreeSale">
                {{ isCourtesy ? 'CORTESÍA' : 'SIN COSTO' }}
              </b>
              <b class="text-uppercase" v-else>
                {{ formPay.type }}
                <span v-if="formPay.card"> - {{ formPay.card }}</span> </b
              >?
            </h4>
            <br />
            <p v-if="paymentSend">
              <b-spinner small></b-spinner>
            </p>
            <p v-if="errorPayment" class="text-action">
              <b class="mr-1">Algo salió mal:</b>
              <span>{{ errorPayment }}</span>
            </p>
            <div style="max-width: 420px; margin: auto">
              <div class="row">
                <div class="col-6">
                  <button
                    @click="closeModalConfirm()"
                    type="button"
                    class="btn btn-secondary btn-lg btn-block"
                  >
                    Cerrar
                  </button>
                </div>
                <div class="col-6">
                  <button
                    @click="onPaymentSend()"
                    :disabled="paymentSend"
                    type="button"
                    class="btn btn-action btn-lg btn-block"
                  >
                    Procesar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
        <!-- modal postdata -->
        <b-modal v-if="false" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
          <h5 class="text-center my-3">
            <b>Ingresar información del POS</b>
          </h5>
          <form @submit.prevent="savePosData()" class="row my-3 p-2">
            <div class="col-12">
              <div class="form-group">
                <label for="code">Código de comercio:</label>
                <input type="text" required maxlength="15" @keypress="onlyNumber($event)" v-model="pos.code" class="form-control" id="code">
              </div>
              <div class="form-group">
                <label for="terminal">Número de terminal:</label>
                <input type="terminal" required maxlength="15" @keypress="onlyNumber($event)" v-model="pos.terminal" class="form-control" id="terminal">
              </div>
              <div class="form-group">
                <label for="brand">Marca:</label>
                <select id="brand" class="form-control" v-model="pos.brand">
                  <option disabled value="">Seleccione una marca</option>
                  <option v-for="brand in brands" :key="brand" :value="brand">{{ brand }}</option>
                </select>
                <!-- <label for="brand">Marca:</label>
                <input type="brand" required  maxlength="20" @keypress="onlyText($event, pos.brand)" v-model="pos.brand" class="form-control" id="brand"> -->
              </div>
              <p v-if="errorPayment" class="text-action">
                <b class="mr-1">Algo salió mal:</b>
                <span>{{ errorPayment }}</span>
              </p>
              <div class="d-block text-right">
                <button
                  :disabled="paymentSend"
                  type="submit"
                  class="btn btn-action btn-lg"
                >
                  <span v-if="!isLoadPos">Guardar</span>
                  <b-spinner v-else small></b-spinner>
                </button>
              </div>
              <div class="row">
              </div>
            </div>
          </form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api';
import ls from '../ls';
import { mapState } from "vuex";
import CardDetailsBuyer from '../components/shopping/CardDetailsBuyer.vue';
import { getSafe, onlyNumber, onlyText } from '../utils/helpers';
import { COURTESY_PAYMENT_METHOD } from '../consts';

const { VUE_APP_BASE_URL_JN } = process.env;
const { VUE_APP_USER_APLICATION, VUE_APP_PASS_APLICATION } = process.env;
const brands = ['IZIPAY','NIUBIZ'];
export default {
  name: 'home',
  components: { CardDetailsBuyer },
  data() {
    return {
      baseUrlJn: VUE_APP_BASE_URL_JN,
      loading: false,
      paymentSend: false,
      events: [],
      coupon: {},
      user: {},
      participants: [],
      formPay: {
        type: 'efectivo',
        card: null,
        code: null,
        detailPayment: null,
      },
      specialPrice: false,
      formSpecial: {
        reason: '',
        amount: 0
      },
      modals: {
        confirm: false,
        confirmNew: false,
        postData: false,
        cashout: false,
      },
      errorPayment: '',
      transactionId: null,
      sellingPointId: 8,
      commission: 0,
      isFootball: false,
      totalDiscountByEvent: 0,
      buycorporate: 0,
      totalsByEvent: {},
      ticketsEmail: '',
      sendingEmail: false,
      pos: {
        code: '',
        terminal: '',
        brand: '',
      },
      isLoadPos: false,
      brands,
      eventSelected: null,
    };
  },
  created() {
    this.getSellingPointId();
    this.getEvents();
  },
  computed: {
    step() {
      return this.$store.state.event.step;
    },
    cart() {
      return this.$store.state.cart.cartEvents;
    },
    meta() {
      return this.$store.getters.cartEventsMeta;
    },
    feePayments() {
      return this.$store.state.cart.feePayments;
    },
    metaData() {
      return this.$store.getters.getMetadata;
    },
    merchandiseBO() {
      return this.$store.state.event.merchandiseBO === 1 ? true : false;
    },
    userBilling() {
      return this.$store.state.billing.userBilling;
    },
    isFeePayments() {
      // if (!this.metaData.length) return false;
      // return this.getMetaValue(this.metaData, 'feePayments') ? true : false;
      if (this.metaData) {
        return this.metaData.feePayments ? true : false;
      } else if (Object.entries(this.userFeePayment).length !== 0) {
        return true;
      } else {
        return false;
      }
    },
    returnPageFeePayment() {
      return this.$store.state.cart.returnPageFeePayment;
    },
    subTotal() {
      let tp = 0;
      if (this.totalDiscountByEvent) {
        return this.meta.total - this.meta.totalProducts * this.totalDiscountByEvent;
      } else {
        if (this.coupon.code) {
          let discount = 0;
          if (this.coupon.name === 'percentage') {
            discount = (this.meta.total * this.coupon.value) / 100;
          } else {
            discount = this.meta.totalProducts * this.coupon.value;
          }
          tp = parseFloat(this.meta.total) - discount;
        } else {
          tp = parseFloat(this.meta.total);
        }
        return tp;
      }
    },
    totalPay() {
      let tp = 0;
      if (this.specialPrice) {
        tp = this.formSpecial.amount;
      } else {
        tp = this.subTotal;
      }
      if (this.isFeePayments && this.feePayments.length) {
        tp = this.feePayments.map((elem) => elem.amount).reduce((prev, curr) => prev + curr, 0);
      } else {
        tp = this.meta.total;
      }

      if (this.coupon.code) {
        let discount = 0;
        if (this.totalsByEvent.discount) discount = this.totalsByEvent.discount;
        else {
          if (this.coupon.type === 1) {
            discount = (this.meta.total * this.coupon.value) / 100;
          } else {
            discount = this.meta.totalProducts * this.coupon.value;
          }
        }
        tp = parseFloat(this.meta.total) - discount;
      }

      return tp ? parseFloat(tp, 2) : 0;
    },
    userFeePayment() {
      return this.$store.state.feePayments.user;
    },
    isCreateFeePayment() {
      return this.$store.state.feePayments.isCreate;
    },
    eventIdFeePayment() {
      return this.$store.state.feePayments.eventId;
    },
    showLoadingJoinnus() {
      return this.$store.state.loadingJoinnus;
    },
    yapeActive() {
      const yape = this.metaData.paymentMethodBoxOffice
      if (yape && yape.includes('yape')) {
        return true
      }
      return false
    },
    sendEmailBoxOffice() {
      const mail =this.metaData.sendEmailBoxOffice
      return mail ? true : false
    },
    userRoles() {
      return this.$store.state.auth && this.$store.state.auth.roles
      ? this.$store.state.auth.roles
      : {};
    },
    isActiveModalPos() {
      return this.$store.getters.getValidPostData;
    },
    isCourtesy() {
      return this.isCourtesyEmail(this.user.email);
    },
    // cortesía o venta que no cobra nada (entrada gratuita, cupón del 100%)
    isFreeSale() {
      if (!this.cart.length) return false;
      return this.isCourtesy || Number(this.totalWithCommission) === 0;
    },
    cartEventTitles() {
      return this.getCartEvents(this.cart)
        .map((el) => el.title)
        .filter(Boolean);
    },
    totalWithCommission() {
      return (this.totalPay + this.commission).toFixed(2);
    },
    ...mapState(["openModalPos"])
  },
  watch: {
    specialPrice(curr) {
      if (curr) {
        this.formSpecial.amount = this.subTotal;
      }
    },
    step(value) {
      if (value === 4) {
        this.$store.dispatch('updateFeePayments', []);
        this.$store.dispatch('changeReservePayments', false);
      }
      // free sales hide the payment methods: drop anything selected before
      if (value === 5 && this.isFreeSale) {
        this.formPay = {
          type: 'efectivo',
          card: null,
          code: null,
          detailPayment: null,
        };
      }
    },
    openModalPos(newValue) {
      if (newValue) {
        this.modals.postData = true;
      }
    }
  },
  methods: {
    getSafe,
    onlyNumber,
    onlyText,
    async onSendTickets() {
      this.sendingEmail = true;
      const { token } = this.$store.state.auth;
      const payload = {
        type: "seller",
        ticketId: this.transactionId,
        email: this.isDummyEmail(this.user.email) ? this.ticketsEmail : this.user.email,
      };
      const data = await api.sendTickets(payload, token);
      if (data.status) {
        this.toast({
          title: 'Éxito',
          description: 'Se enviaron correctamente las entradas.',
          variant: 'success',
        })
      } else {
        this.toast({
          title: 'Hubo un error',
          description: data.message || 'No se pudieron enviar los entradas.',
          variant: 'danger',
        })
      }
      this.sendingEmail = false;
      this.modalSendEmail = false;
    },
    deleteSessionStorage() {
      ls.removeItem('fp-user');
    },
    newSale() {
      this.modals.confirmNew = true;
    },
    returnPage() {
      if (this.returnPageFeePayment) {
        this.$router.back();
        this.$store.dispatch('returnPageFeePayment', false);
        this.$store.dispatch('changeIsCreateFeePayment', true);
      } else {
        this.goStep(this.isFeePayments ? 4 : 3);
      }
    },
    totalDiscount(value) {
      this.totalDiscountByEvent = Number(value);
    },
    goStep(step) {
      this.$store.dispatch('changeStep', step);
    },
    print() {
      window.print();
    },
    newShop() {
      window.location.reload();
      this.$store.dispatch('resetStateFeePayment');
      this.$store.commit('cleanCartEvents');
      // reset: data user buyed
      // this.$refs.formUserData.resetData();
      this.deleteSessionStorage();
    },
    searchSubmit(text) {
      this.getEvents(`&search=${text}`);
    },
    async getEvents(q) {
      this.loading = true;
      try {
        const email = VUE_APP_USER_APLICATION;
        const password = VUE_APP_PASS_APLICATION;
        const accessToken = btoa(`${email}:${password}`);
        const res = await api.getAccessToken(accessToken);
        if (res && res.data && res.data.accessToken) {
          const data = await api.getNewListEvents(res.data.accessToken, q);
          if (data && data.items) {
            this.events = data.items;
            if (this.userRoles && this.userRoles.length){
              const isSeller = this.userRoles.some( u => u.name === 'Vendedor');
              const now = new Date();
              const existDatePos = localStorage.getItem('availablePos');
              let isValidPos = true;
              if (existDatePos) {
                const difference = now.getTime() - Number(existDatePos);
                const hoursDifference = difference / (1000 * 60 * 60);
                isValidPos = hoursDifference < 24;
              }
              this.$store.dispatch('setPosData', Boolean(existDatePos && isValidPos));
              if (isSeller && (!existDatePos || !isValidPos)) {
                this.modals.postData = data.requiredPosData;
              }
            }
        }
        } else {
          this.events = []
        }
      } catch (error) {
        this.events = []
        console.log(error);
        this.logout();
      } finally {
        this.loading = false;
      }
    },
    async savePosData() {
      try {
        this.isLoadPos = true;
        const sessionId = this.$store.state.auth.token;
        const { brand, code, terminal } = this.pos;
        const payload = {
          brand,
          merchant: code,
          terminal,
          collectionSource: 'joinnus2'
        }
        const res = await api.saveDataPost(payload, sessionId);
        if(res.success) {
          this.modals.postData = false;
          const now = new Date();
          localStorage.setItem('availablePos', now.getTime());
          this.$store.dispatch('setPosData', true);
          this.$store.dispatch('setBrandSelected', brand.toLowerCase());
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadPos = false;
      }
    },
    updateCart(cart) {
      this.$store.commit('updateCartEvents', cart);
    },
    registerDataUser(data) {
      this.user = data.user;
      this.buycorporate = data.buycorporate;
      this.participants = data.participants;
      this.$store.dispatch('changeStep', this.isFeePayments ? 4 : 5);
      this.$store.dispatch('changeIsCreateFeePayment', true);
    },
    closeModalConfirm() {
      this.modals.confirm = false;
    },
    async onPaymentSend() {
      this.errorPayment = '';
      this.paymentSend = true;
      try {
        const sessionId = this.$store.state.auth.token;
        const { name, lastname, email, document, documentType, phone, sexo } = this.user;
        const { reason, amount } = this.formSpecial;
        let user = {
          name,
          lastname,
          phone,
          email,
          document,
          documentType,
          sexo,
          sessionId,
          deviceSessionID: null,
          origin: 'white-label-pos',
          source: 'web',
          iso: 'PE',
          // extra
          date_birthday: '',
          provincia: ''
        };
        // let events = this.$store.getters.dataEventsSend;
        let events = [];
        const eventsCart = this.getCartEvents(this.cart);
        events = this.dataEventsSend(eventsCart);

        if (this.isFeePayments && !this.isCreateFeePayment) {
          user.name = this.userFeePayment.firstName;
          user.lastname = this.userFeePayment.lastName;
          user.email = this.userFeePayment.email;
          user.phone = this.userFeePayment.phone;
          user.document = this.userFeePayment.document;
          user.documentType = this.userFeePayment.documentType;
          user.sexo = this.userFeePayment.gender;
          user.phone = this.userFeePayment.phoneUser;
          user.nacionality  = 'PE';
          events = [{ id: this.eventIdFeePayment }];
        }

        let coupon = '';
        if (this.merchandiseBO) {
          coupon = { code: this.coupon.code };
        }

        let cardType = this.formPay.card || '';
        if (this.formPay.type === 'YAPE' || this.formPay.type === 'PLIN') {
          cardType = this.formPay.type;
          this.formPay.type = 'efectivo';
          this.formPay.code = this.formPay.type;
        }

        let method_payment = '';
        if (this.isFreeSale) {
          method_payment = COURTESY_PAYMENT_METHOD;
        } else if (this.formPay.type === 'parts') {
          method_payment = 'efectivo';
        } else if (this.formPay.type === 'yape') {
          method_payment = 'pos';
        } else if (this.formPay.type === 'transferencia') {
          method_payment = 'pos';
        } else {
          method_payment = this.formPay.type;
        }

        let formatCardType = this.formPay.type !== 'parts' ? cardType.toLowerCase() : 'fee-payment'
        if (this.isFreeSale) {
          formatCardType = '';
        } else if (this.formPay.detailPayment) {
          formatCardType = `${this.formPay.detailPayment}-${formatCardType}`;
        }

        const payment = {
          ip: null,
          method_payment: method_payment,
          currency: this.meta.currencyIso,
          specialPrice: this.specialPrice,
          paymentTotal: amount !== 0 ? amount : this.total,
          reason: this.formPay.type === 'transferencia' ? 'transferencia' : reason,
          cardType: formatCardType,
        };

        let codepos = this.formPay.code;
        // const userBilling = this.userBilling && this.userBilling.id ? this.userBilling.id : this.buycorporate;
        const buycorporate = this.userBilling.businessIdentifier ? 1 : 0;
        const { participants } = this;
        // eslint-disable-next-line no-unused-vars
        const participantFormat = participants.map(({ extraFields, ...rest }) => rest);
        let extraFieldsFormat = null
        if (
          this.eventSelected &&
          Array.isArray(this.eventSelected.extraFields) &&
          this.eventSelected.extraFields.length > 0
        ) {
          extraFieldsFormat = {
            fields: this.eventSelected.extraFields.map(({ fieldName: name, fieldLabel: label, value }) => ({
              name,
              label,
              value: value || ''
            }))
          }
        }
        let payload = {
          sellingPointId: this.sellingPointId,
          user,
          coupon,
          payment,
          events,
          participants: participantFormat,
          feePayments: this.feePayments,
          sellingUser: this.$store.state.auth.user.id,
          source: 'box-office',
          createTicket: this.isCreateFeePayment,
          ticketId: this.isCreateFeePayment ? '' : this.userFeePayment.transaction,
          // buycorporate: userBilling,
          buycorporate,
          dataBilling: buycorporate ? this.userBilling : null,
        };

        if( extraFieldsFormat ) {
          payload.extraFields = extraFieldsFormat;
        }

        if (codepos) {
          payload.codepos = codepos;
          payment.information = codepos;
        }
        if (this.formPay.type === 'yape') {
          payload.codepos = 'yape';
          payment.cardType = 'yape';
          payment.information = 'yape';
        }

        if (this.formPay.type === 'parts' && Array.isArray(codepos)) {
          const codes = codepos.map((elem) => {
            delete elem.id;
            delete elem.methods;
            return elem;
          });
          payload.codepos = JSON.stringify(codes);
          this.formPay.type = 'efectivo';
        }
        const token = this.signToken(payload);
        const url = `${api.checkoutUrl}/payment/process/point-of-sale`;
        const { data: res } = await api.axios.post(url, { data: token });
        if (!res.success) {
          this.errorPayment = res.messagePayment;
          return;
        }
        this.transactionId = res.data.ticketId;
        this.isFootball = res.data.isFootball;
        this.closeModalConfirm();
        this.$store.commit('cleanCartEvents');
        this.$store.dispatch('changeStep', 6);

        // reset: formas de pago
        this.formPay = {
          type: 'efectivo',
          card: null,
          code: null,
          detailPayment: null
        };
        // reset: coupon
        this.coupon = {};
      } catch (error) {
        console.error(error);
        this.errorPayment = "Inténtalo más tarde.";
      } finally {
        this.paymentSend = false;
      }
    },
    resetModalPayment(){
      this.errorPayment = false;
    },
    async getSellingPointId() {
      try {
        const sessionId = this.$store.state.auth.token;
        const url = `/marca-blanca/point-of-sale?session=${sessionId}`;
        const { data: res } = await api.axios.get(url);
        if (res.success) {
          const [sellingPointId] = Object.keys(res.data);
          this.sellingPointId = sellingPointId;
          this.commission = res.commission || 0;
        }
      } catch (error) {
        console.log(error);
        this.paymentSend = false;
      }
    },
    setPartPayment(value) {
      this.formPay = value;
      this.formPay.card = value.card;
      this.formPay.code = value.code;
      this.formPay.detailPayment = value.detailPayment;
    },
    setCoupon(value, ticket) {
      this.coupon = value;
      const data = { ...value, ...ticket };
      this.$store.dispatch('changeCouponEvent', data);
    },
    changeValuesFormPay(type, card, code) {
      this.formPay = type;
      this.formPay.card = card.toLowerCase();
      this.formPay.code = code;
    },
    logout(){
      this.$store.dispatch('logout');
      this.$store.commit('cleanCartProducts');
      this.$router.push({ name: 'Login' });
    },
    getEventSelected(event) {
      this.eventSelected = event;
    }
  },
};
</script>
